<p-drawer
  [(visible)]="visible"
  header="Activity log"
  position="right"
  [styleClass]="'!w-full lg:!w-1/2 2xl:!w-1/3'"
>
  @if (visible()) {
    @let logs = logs$ | async;
    <div class="rounded-xl border border-surface-switch-200 shadow-sm mt-4">
      <div
        class="hidden lg:grid rounded-t-xl bg-surface-switch-100 items-center gap-4 px-4 py-3 text-sm font-bold text-surface-switch-600 uppercase"
        style="grid-template-columns: 0.5fr 1.2fr 1.6fr 1.3fr"
      >
        <div>No.</div>
        <div>Date/Time</div>
        <div>Account</div>
        <div>Action</div>
      </div>

      @if (logs && logs.length > 0) {
        <div class="flex flex-col">
          @for (log of logs; track log.id) {
            <div
              class="border-b border-surface-switch-200 last:border-b-0 bg-surface-switch-50 transition-colors duration-200 hover:bg-surface-switch-100"
            >
              <div class="lg:hidden p-4 flex flex-col gap-2">
                <div class="flex items-center justify-between">
                  <span class="font-semibold">#{{ log.number }}</span>
                  <span class="text-sm text-muted-color">
                    {{ log.created_date | date: "d MMM, y HH:mm" }}
                  </span>
                </div>
                <div class="text-sm">
                  <span class="font-semibold text-muted-color">Account: </span>
                  {{ log.user_email }}
                </div>
                <div class="text-sm">
                  <span class="font-semibold text-muted-color">Action: </span>
                  {{ log.action }}
                </div>
              </div>

              <div
                class="hidden lg:grid lg:items-center lg:gap-4 lg:px-4 lg:py-3"
                style="grid-template-columns: 0.5fr 1.2fr 1.6fr 1.3fr"
              >
                <div class="text-sm">{{ log.number }}</div>
                <div class="text-sm">
                  {{ log.created_date | date: "d MMM, y HH:mm" }}
                </div>
                <div class="text-sm">{{ log.user_email }}</div>
                <div class="text-sm">{{ log.action }}</div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="text-center text-muted-color py-8">
          <i class="pi pi-inbox text-4xl mb-4 block"></i>
          <p>No logs found</p>
        </div>
      }
    </div>
  }
</p-drawer>
